import type { ICheckFetch } from '../interfaces'
import type { AxiosResponse } from 'axios'

import $api, { checkRegister } from '.'
export interface IPropsGetCheckRegister {
  countRows: number
  currentPage: number
  fromDate?: string
  toDate?: string
  groupName?: string
}
export interface fetchDownload {
  file: Blob
  name: string
}
export interface DownLoadProps {
  fileKey: string
  entId: string
  groupNumber: string
}

const quotesPattern = /^"{0,1}(.+?)"{0,1}$/i

export default class CheckRegister {
  static async getCheckRegister(paramsGet: IPropsGetCheckRegister): Promise<ICheckFetch> {
    return $api
      .get<ICheckFetch>(`${checkRegister}/getData`, { params: paramsGet })
      .then((response: AxiosResponse) => {
        return { data: response.data, status: response.status }
      })
  }

  static async getCheckRegisterDownload(params: DownLoadProps): Promise<fetchDownload> {
    return $api
      .get<fetchDownload>(`${checkRegister}/getReport`, {
        params,
        responseType: 'blob',
        headers: {}
      })
      .then((response: AxiosResponse) => {
        const name = response.headers['content-disposition']
        const splitName = name.split('=')
        const returnName = splitName[1]
        const quotesMatch = returnName.match(quotesPattern)
        const normalizedName = quotesMatch ? quotesMatch[1] : returnName

        return { file: response.data, name: normalizedName }
      })
  }
}
